import $ from 'jquery';


export class Home {
    constructor() {

        if($("#new-project").get(0) != undefined){
            let modal_import = new bootstrap.Modal(document.getElementById('modal-dialog-import-project'), "show");
            let modal_new_project = new bootstrap.Modal(document.getElementById('modal-dialog-new-project'), "show");

            $("#new-project").click(function(){
                modal_new_project.show();
            });

            $("#import_button").click(function(){
                modal_import.show();
            });
            //
            // $(".modal-close").click(function(){
            //     modal_new_project.hide();
            //     modal_import.hide();
            // });
        }

        $("#import-project-wrapper").click(function(event){
            $(this).prop("disabled", true);
            $("#import-project").trigger('click');
        });

        $("#import-project").on("change", function(){
            var formData = new FormData($("form")[0]);
            console.log(formData);
            $.ajax({
                url : ajaxurlobject,
                type : "POST",
                data : formData,
                contentType: false,
                processData: false,
                success: function(response){
                    console.log('The server responded: ', response);
                    window.location.href = $("#import-project-wrapper").attr("data-redirect");
                }
            });
        });
    }
}
